import { Button } from 'react-bootstrap';
import React, { useEffect } from 'react';

import { getPhoneComposerToOptions } from 'screens/leadModal/lib/messagesUtilities.js';
import { useSelector } from 'react-redux';
import { appDetailTypesSelector } from '../../../../../../selectors/lib/appDetailTypesSelector.js';
import ComposerModal from '../../ComposerModal.js';
import PillSelect from '../../../../../../components/PillSelect.js';
import sortByProp from '../../../../../../lib/sortByProp.js';
import selectors from '../../../../../../selectors/selectors.js';
import useBoundForm from '../../../../../../hooks/useBoundForm.js';
import { sendChatComposerReviewLoop } from '../../../../redux/leadModalActions.js';

const ReviewLoopComposer = () => {
  const activeLead = useSelector(selectors.activeLead) || {};
  const detailTypes = useSelector(appDetailTypesSelector);
  const reviewloopAccounts = (useSelector(selectors.serviceProviderPlatformRegistrations) || []).filter((n) => n.platform_code === 'reviewloop');

  const { service_location_id, contacts } = activeLead;
  const supportedLocationIds = reviewloopAccounts.map((n) => n.service_location_id);

  const form = useBoundForm({
    id: 'reviewLoopComposer',
    initialState: {
      description: '',
      contactId: null,
      contact_detail_id: null,
      service_location_id: null,
      message: '',
    },
  });

  useEffect(() => {
    let location = (reviewloopAccounts || []).find((n) => n.service_location_id === service_location_id) || (reviewloopAccounts || [])[0];
    if (location) {
      form.set('service_location_id', location.service_location_id);
    }
  }, [reviewloopAccounts.length]);

  useEffect(() => {
    if (contacts) {
      const formattedContacts = getPhoneComposerToOptions(contacts, detailTypes);
      if (formattedContacts.length) {
        form.set('contact_id', formattedContacts[0].id);
        form.set('contact_detail_id', formattedContacts[0].detailsData.id);
      }
    }
  }, [contacts]);

  const handleSend = () => {
    sendChatComposerReviewLoop(() => {
      form.set('message', '');
    });
  };

  const sendDisabled = !form.state.contact_detail_id;
  const locationOptions = reviewloopAccounts.map((n) => ({ id: n.service_location_id, label: n.name }));
  const sendToOptions = getPhoneComposerToOptions(contacts, detailTypes)
    .map((n) => ({ id: n.dropdownId, contactId: n.id, label: n.dropdownValue }))
    .sort(sortByProp('label'));
  const blurred = !supportedLocationIds.includes(service_location_id);

  return (
    <ComposerModal className={`reviewloop-send-composer ${blurred ? 'blurred' : ''}`} title={'ReviewLoop'} focusElement={blurred ? null : `.reviewloop-send-composer-message`}>
      <div className={'composer-row'}>
        <div className={'label'}>To</div>
        <div className={'content'}>
          <PillSelect
            options={sendToOptions}
            value={form.state.contact_detail_id}
            onChange={(option) => {
              form.set('contact_detail_id', option.id);
              form.set('contact_id', option.contactId);
            }}
          />
        </div>
      </div>
      <div className={'composer-row'}>
        <div className={'label'}>Location</div>
        <div className={'content'}>
          <PillSelect options={locationOptions} value={form.state.service_location_id} onChange={(n) => form.set('service_location_id', n.id)} />
        </div>
      </div>
      <div className={'composer-content'}>
        <textarea name="message" placeholder={'Type your message here (leave blank for default message)'} value={form.state.message} onChange={(e) => form.set('message', e.target.value)} className={`reviewloop-send-composer-message`} spellCheck={true} />
      </div>
      <div className={'composer-footer'}>
        <div className={'left'}>
          {blurred && (
            <a className={'btn link btn-primary'} href="https://www.reviewloop.app/" target="_blank" title="Reviewloop link" alt={'reviewloop link'}>
              Connect to Reviewloop
            </a>
          )}
          {!blurred && (
            <Button disabled={sendDisabled} onClick={handleSend}>
              Send
            </Button>
          )}
        </div>
      </div>
    </ComposerModal>
  );
};

export default ReviewLoopComposer;
